import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreDirectives } from '@core/directives/core.directives';

import { CoreModule } from '@core/core.module';
import { FilesModule } from '@core/components/files/files.module';

import { OrganizationProfileLogoMainComponent } from './main/main.component';
import { OrganizationProfileLogoEditComponent } from './edit/edit.component';
import { OrganizationProfileLogoUploadComponent } from './upload/upload.component';
import { OrganizationLogoImgComponent } from './logo-img/logo-img.component';


@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        CoreModule,
        CoreDirectives,
        // LogoModule,
        // FilesModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        OrganizationProfileLogoMainComponent,
        OrganizationProfileLogoEditComponent,
        OrganizationProfileLogoUploadComponent,
        OrganizationLogoImgComponent
    ],
    exports: [
		OrganizationProfileLogoMainComponent,
        OrganizationProfileLogoEditComponent,
        OrganizationProfileLogoUploadComponent,
        OrganizationLogoImgComponent
	],

})
export class OrganizationProfileLogoModule { }
